define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/locale",
	"csi/table/Widget",
	"./_Store",
	"./_TableMixin"
], function(declare,csi,_,locale,Table,_Store,_TableMixin) {

	var	_ResourceStore = declare(_Store, {
		_resolveData: function(/*Deferred*/dfd) {
			// summary: create node per resource that is not enumeration
			var	resources = _.keys(this.lrBaseSite.localeResources.resources).sort();
			var	data = [];

			csi.forEachWithTimeout(
				resources, 
				100,
				null,
				function(key) {
					// filter out enumerations which will be shown separately
					if (!locale.isEnumResource(key)) {
						data.push(this._createNode(key));
					}
				},
				function() {
					dfd.resolve(data);
				},
				this
			);			
		}
	});

	return declare([Table,_TableMixin], {
		storeClass: _ResourceStore
	});
});